function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#003B81",
  fillRule: "evenodd",
  d: "M0 0h27l-2 4H0z"
});

var SvgH1HeadlineDecoration = function SvgH1HeadlineDecoration(props) {
  return React.createElement("svg", _extends({
    width: 27,
    height: 4
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgMjcgNCI+CiAgICA8cGF0aCBmaWxsPSIjMDAzQjgxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDBMMjcgMCAyNSA0IDAgNHoiLz4KPC9zdmc+Cg==";
export { SvgH1HeadlineDecoration as ReactComponent };